"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _he = _interopRequireDefault(require("he"));

var _ThemeProvider = require("../../ThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Chip =
/*#__PURE__*/
function (_Component) {
  _inherits(Chip, _Component);

  function Chip() {
    _classCallCheck(this, Chip);

    return _possibleConstructorReturn(this, _getPrototypeOf(Chip).apply(this, arguments));
  }

  _createClass(Chip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          className = _this$props.className,
          deletable = _this$props.deletable,
          children = _this$props.children,
          onDeleteClick = _this$props.onDeleteClick;
      var classes = (0, _classnames2["default"])(theme.chip, _defineProperty({}, theme.deletable, deletable), className);
      return _react["default"].createElement("div", {
        className: classes
      }, typeof children === 'string' ? _react["default"].createElement("span", null, _he["default"].decode(children)) : children, deletable ? _react["default"].createElement("span", {
        className: theme["delete"],
        onClick: onDeleteClick
      }, _react["default"].createElement("svg", {
        viewBox: "8 9 25 25",
        className: theme.deleteIcon
      }, _react["default"].createElement("path", {
        className: theme.deleteX,
        d: "M 12,12 L 28,28 M 28,12 L 12,28"
      }))) : null);
    }
  }]);

  return Chip;
}(_react.Component);

_defineProperty(Chip, "propTypes", {
  theme: _propTypes["default"].shape({
    deleteIcon: _propTypes["default"].string,
    deletable: _propTypes["default"].string
  }).isRequired,
  className: _propTypes["default"].string,
  deletable: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  onDeleteClick: _propTypes["default"].func
});

_defineProperty(Chip, "defaultProps", {
  className: '',
  deletable: false,
  children: null,
  onDeleteClick: function onDeleteClick() {}
});

var _default = (0, _ThemeProvider.applyTheme)('Chip', Chip);

exports["default"] = _default;